export const apiUrl = 'https://raw.githubusercontent.com/mild-blue/about/master';

export const MoreInfoType = {
  Email: 'email',
  Web: 'web'
};

export const BASE_OPTIONS = {
  team: ['tomas', 'honza', 'marek', 'lukas', 'nasta', 'beta'],
  projects: ['breviary', 'txm', 'datavid', 'ekg'],
  showCooperation: false,
  showSubtitle: true,
  showCoFounderLabel: true,
  footerLinkType: MoreInfoType.Email
};
